export default __webpack_public_path__ + "static/media/no-elements.f72cb3dd.svg";